/* Campos de personalizacion TCKC — reemplazo de Infinite Options.
   La definicion vive en el metacampo custom.opciones de cada producto.
   Aqui solo esta la logica del campo condicional ("otro") y el aviso del archivo. */
(function () {
  'use strict';

  if (window.__tckcOpcionesListo) return;
  window.__tckcOpcionesListo = true;

  function normalizar(s) {
    return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  }

  function sincronizar(select) {
    var campo = select.closest('[data-op-campo]');
    if (!campo) return;
    var siguiente = campo.nextElementSibling;
    while (siguiente && !siguiente.hasAttribute('data-op-otro')) {
      siguiente = siguiente.matches('[data-op-campo]') ? null : siguiente.nextElementSibling;
    }
    if (!siguiente) return;
    var gatillo = normalizar(siguiente.dataset.opOtro || 'otro');
    var abre = normalizar(select.value).indexOf(gatillo) !== -1;
    siguiente.hidden = !abre;
    var input = siguiente.querySelector('input, textarea');
    if (input) {
      input.disabled = !abre;
      if (!abre) input.value = '';
    }
  }

  document.addEventListener('change', function (ev) {
    if (!ev.target.matches || !ev.target.matches('select[data-op-lista]')) return;
    if (!ev.target.closest('[data-tckc-op]')) return;
    sincronizar(ev.target);
  });

  document.addEventListener('change', function (ev) {
    if (!ev.target.matches || !ev.target.matches('input[type="file"][data-op-archivo]')) return;
    var aviso = ev.target.parentNode.querySelector('[data-op-archivo-aviso]');
    if (!aviso) return;
    var f = ev.target.files && ev.target.files[0];
    aviso.textContent = f ? f.name + ' · ' + Math.round(f.size / 1024) + ' KB' : '';
    aviso.hidden = !f;
  });

  function hidratar() {
    document.querySelectorAll('[data-tckc-op] select[data-op-lista]').forEach(sincronizar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hidratar);
  } else {
    hidratar();
  }

  var pendiente = null;
  new MutationObserver(function () {
    if (pendiente) return;
    pendiente = setTimeout(function () {
      pendiente = null;
      hidratar();
    }, 80);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
